import {TimelineMax, Linear} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');


const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');

    const view = new PIXI.Graphics();

    const m1 = Shortcuts.addTo(Shortcuts.getSprite('m1', TextureCache), 'm1', view);
    m1.anchor.set(1061.2 / 3219, 1);
    m1.position.set(113.9, 0);

    const m2 = Shortcuts.addTo(Shortcuts.getSprite('m2', TextureCache), 'm2', view);
    m2.anchor.set(1181.6 / 1911, 1);
    m2.position.set(-2540, 0);

    const m3 = Shortcuts.addTo(Shortcuts.getSprite('m3', TextureCache), 'm3', view);
    m3.anchor.set(322.5 / 847.8, 1);
    m3.position.set(113.9, 0);

    const m4 = Shortcuts.addTo(Shortcuts.getSprite('m4', TextureCache), 'm4', view);
    m4.anchor.set(728.95 / 1457.95, 1);
    m4.position.set(113.9, 0);

    const m5 = Shortcuts.addTo(Shortcuts.getSprite('m5', TextureCache), 'm5', view);
    m5.anchor.set(1111.95 / 3008.95, 1);
    m5.position.set(113.9, 0);

    const m6 = Shortcuts.addTo(Shortcuts.getSprite('m6', TextureCache), 'm6', view);
    m6.anchor.set(649.1 / 2190.1, 1);
    m6.position.set(113.9, 0);

    const m7 = Shortcuts.addTo(Shortcuts.getSprite('m7', TextureCache), 'm7', view);
    m7.anchor.set(537.7 / 1293.05, 1);
    m7.position.set(113.9, 0);

    const m8 = Shortcuts.addTo(Shortcuts.getSprite('m8', TextureCache), 'm8', view);
    m8.anchor.set(869.4 / 1534.45, 1);
    m8.position.set(113.9, 0);

    const m9 = Shortcuts.addTo(Shortcuts.getSprite('m9', TextureCache), 'm9', view);
    m9.anchor.set(744.95 / 1385.5, 1);
    m9.position.set(113.9, 0);

    const a = 0.6;
    m3.z = -0.4 + a;
    m9.z = -0.1 + a;
    m7.z = a;
    m2.z = 0.2 + a;
    m4.z = 0.4 + a;
    m1.z = 0.7 + a;
    m5.z = 1.1 + a;
    m6.z = 1.4 + a;

    m1.zYFactor = m2.zYFactor = m3.zYFactor = m4.zYFactor = m5.zYFactor = m6.zYFactor = m7.zYFactor = m8.zYFactor = m9.zYFactor = 0.01;


    const overlay = new PIXI.Graphics();
    Shortcuts.rect(overlay, 0, 0, sizes.width, sizes.height, 0x000000);
    overlay.alpha = 0;
    view.alpha = 0;

    view.position.set(sizes.width / 2, sizes.height);

    cont.addChild(view);
    cont.addChild(overlay);

    instance.cont = cont;
    instance.view = view;
    instance.width = sizes.width;
    instance.height = sizes.height;
    instance.overlay = overlay;

    instance.parallaxLayers = [m1, m2, m3, m4, m5, m6, m7, m8, m9];
    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}


const _constructTimeline = instance => {
    const tl = new TimelineMax({paused: true});
    // const d1 = 2.4 + 0.4, d2 = 4;

    tl.set(instance.view, {alpha: 1}, 'in');
    /* tl.set(instance.overlay, {alpha: 0}, 'in');

    tl.to(instance.overlay, d1 - 0.4, {alpha: 1}, 'in+=' + 0.4);
    tl.to(instance.overlay, d2, {alpha: 0}, 'out');*/

    const view = instance.view;
    const a = 0.2;

// __________________M1_______________

  tl.set(view.m1, {x:-4199}, 'in');
    tl
        .to(view.m1,  25 * a, {x:2700, ease: Linear.easeInOut}, 'in');

// __________________M2_______________

    tl.set(view.m2, {x:-2540}, 'in');
    tl
        .to(view.m2, 28 * a, {x:3650, ease: Linear.easeInOut}, 'in+=' +  0.6 * a);
// __________________M3_______________

    tl.set(view.m3, {x:-3743}, 'in');
    tl
        .to(view.m3,  27 * a, {x:2420, ease: Linear.easeInOut}, 'in+=' + 0.2 * a);
// __________________M4_______________

    tl.set(view.m4, {x:-3500}, 'in');
    tl
        .to(view.m4,  25 * a, {x:3007, ease: Linear.easeInOut}, 'in+=' + 0.1 * a);
// __________________M5_______________

    tl.set(view.m5, {x:-2811}, 'in');
    tl
        .to(view.m5,  28 * a, {x:3899, ease: Linear.easeInOut}, 'in+=' + 0.8 * a);

// __________________M6_______________

    tl.set(view.m6, {x:-4898}, 'in');
    tl
        .to(view.m6,  20 * a, {x:2298, ease: Linear.easeInOut}, 'in+=' + 0.1 * a);
// __________________M7_______________

    tl.set(view.m7, {x:-2150}, 'in');
    tl
        .to(view.m7,  26 * a, {x:3393, ease: Linear.easeInOut}, 'in+=' + 0.1 * a);
    // __________________M8_______________

    tl.set(view.m8, {x:-2460}, 'in');
    tl
        .to(view.m8, 35 * a, {x:3950, ease: Linear.easeInOut}, 'in+=' +  0.6 * a);
    // __________________M9_______________

    tl.set(view.m9, {x:-1800}, 'in');
    tl
        .to(view.m9, 31 * a, {x:4150, ease: Linear.easeInOut}, 'in+=' +  0.6 * a);





    instance.timeline = tl;
    return tl;
}


function MountainsTransition(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = 0.2 * (0.29 * 28 + 0.6);
    constructor.transitionDuration = 0.2 * (0.31 * 28);
    constructor.totalDuration = 0.2 * (35 + 0.6);

    return constructor;
}


module.exports = MountainsTransition;



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/transitions/MountainsTransition.js